import { useState } from "react";
import { Reply } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MailOutDialog } from "@/components/mail-out-dialog";
import { useAuth } from "@/contexts/auth-context";

interface PulseReplyButtonProps {
  pulseId: number;
  projectId: string;
  className?: string;
}

/**
 * Shared entry point for replying from every incoming-email surface.
 * MailOutDialog resolves the authoritative email-cache source from the pulse.
 */
export function PulseReplyButton({ pulseId, projectId, className }: PulseReplyButtonProps) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  if (user?.role !== 'admin' && user?.role !== 'team') return null;

  return (
    <>
      <Button
        type="button"
        size="sm"
        onClick={() => setOpen(true)}
        className={className || "bg-blue-600 hover:bg-blue-500 text-white"}
        aria-label="Reply to incoming email"
        data-testid={`button-reply-email-pulse-${pulseId}`}
      >
        <Reply className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
        Reply
      </Button>
      <MailOutDialog
        open={open}
        onOpenChange={setOpen}
        projectId={projectId}
        composeLabel="Reply"
        replySource={{ pulseId }}
      />
    </>
  );
}